import { Button, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import type {
  BorrowingBaseMechanicsForLoanProduct,
  CreditFacility,
  ExclusionSqlClauseState,
  PossibleLoanProductCriteria,
} from '../../types';
import { LoanProductCriteriaBlock } from './LoanProductCriteriaBlock';
import { Icon } from 'packages/common-frontend/components/icons';

export const ExclusionCriteriaSection = ({
  currentLoanProductCriteria,
  setCurrentLoanProductCriteria,
  creditFacilitiesForAssignmentGrouping,
  currentExclusionSqlClauseStates,
  showExclusionSqlClauseRuleErrors,
  validLoanProductsForCreditFacilitiesMap,
  borrowingBaseMechanicsMap,
  readOnly,
}: {
  currentLoanProductCriteria: PossibleLoanProductCriteria[];
  setCurrentLoanProductCriteria: React.Dispatch<
    React.SetStateAction<PossibleLoanProductCriteria[]>
  >;
  creditFacilitiesForAssignmentGrouping: CreditFacility[];
  currentExclusionSqlClauseStates: React.MutableRefObject<
    Map<number, ExclusionSqlClauseState>
  >;
  showExclusionSqlClauseRuleErrors: boolean;
  validLoanProductsForCreditFacilitiesMap: Map<string, string[]>;
  borrowingBaseMechanicsMap: Map<string, BorrowingBaseMechanicsForLoanProduct>;
  readOnly: boolean;
}) => {
  const creditFacilityOptions = creditFacilitiesForAssignmentGrouping.map(
    (creditFacility) => ({
      value: creditFacility.id,
      label: creditFacility.name,
    }),
  );

  return (
    <>
      <Flex mt="24px" mb="24px">
        <Flex direction="column" mr="24px" maxWidth="300px" minWidth="300px">
          <Text fontSize="md" mb="16px" fontWeight="600">
            Exclusion Criteria
          </Text>
          <Text fontSize="md" mb="16px" color="gray">
            Set up discretionary exclusion criteria.
          </Text>
          <Text fontSize="md" mb="16px" color="gray">
            If field(s) needed to assess criteria are missing, the receivable(s)
            will not be excluded.
          </Text>
        </Flex>
        <Flex direction="column" width="100%">
          {currentLoanProductCriteria.map((loanProductCriteria, index) => {
            return (
              <LoanProductCriteriaBlock
                loanProductCriteria={loanProductCriteria}
                key={
                  // eslint-disable-next-line react/no-array-index-key
                  `${loanProductCriteria.creditFacilityId}+${loanProductCriteria.loanProductId}+${index}`
                }
                index={index}
                creditFacilityOptions={creditFacilityOptions}
                borrowingBaseMechanicsMap={borrowingBaseMechanicsMap}
                setCurrentLoanProductCriteria={setCurrentLoanProductCriteria}
                validLoanProductsForCreditFacilitiesMap={
                  validLoanProductsForCreditFacilitiesMap
                }
                currentExclusionSqlClauseStates={
                  currentExclusionSqlClauseStates
                }
                showExclusionSqlClauseRuleErrors={
                  showExclusionSqlClauseRuleErrors
                }
                loanProductCriteriaCount={currentLoanProductCriteria.length}
                readOnly={readOnly}
              />
            );
          })}

          {!readOnly && (
            <Button
              colorScheme="aurora"
              variant="outline"
              onClick={() => {
                setCurrentLoanProductCriteria((oldLoanProductCriteria) => {
                  const newLoanProductCriteria = [...oldLoanProductCriteria];
                  newLoanProductCriteria.push({
                    id: undefined,
                    creditFacilityId: undefined,
                    loanProductId: undefined,
                  });
                  return newLoanProductCriteria;
                });
              }}
              leftIcon={<Icon icon="plus" />}
              width="fit-content"
            >
              Add Exclusion Criteria
            </Button>
          )}
        </Flex>
      </Flex>
      <hr />
    </>
  );
};
